import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setToken, setIsAdmin } = useAuth();
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const BASE_URL = process.env.REACT_APP_API_URL;
      const res = await fetch(`${BASE_URL}/api/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) return toast.error(data.error || "Login failed");

      if (data.user?.role === "admin") {
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("isAdmin", "true");
        setToken(data.token);
        setIsAdmin(true);
        toast.success("Admin login successful");
        setTimeout(() => navigate("/admin/dashboard"), 500);
      } else {
        toast.error("Access denied: You are not an admin.");
      }
    } catch (error) {
      toast.error("Server error. Try again.");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="slider-container">
        <div className="slider-text">⚠️ Only Admin Can Login ⚠️</div>
      </div>
      <h2>Admin Login</h2>
      <p>Please enter your admin credentials to access the dashboard.</p>
      <form onSubmit={handleLogin} className="admin-login-form">
        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}
